module.exports = __webpack_public_path__ + "static/media/homeBox.75a52141.svg";